module.exports = __webpack_public_path__ + "img/move26.e8c3ee65.jpg";